import ResultPage from '@/components/Result/index';
import { assetUrl } from '@/utils/asset-url';
import { useLocation } from '@/lib/router-dom/index';

const ApprovalTransactionSuccessPage = () => {

    const { currentState } = useLocation();
    const type = currentState?.type;
    const transactionRequestId = currentState?.transactionRequestId;
    const transferableRecordId = currentState?.transferableRecordId;

	const breadcrumbsItem = [
		{
			label: '',
			link: '/'
		 },
		{
			label: 'Approvals',
			link: '/approvals'
		}
	]

    return ResultPage({
		layoutHeaderTxt: type,
        layoutContentImgPath: assetUrl("/img/theme-success.png"),
        backBtnTxt: 'Back to Approval Page',
        breadcrumbs: breadcrumbsItem,
        nextLocation: '/approvals',
        viewRecordLocation: `/approvals/transaction/${transactionRequestId}/${transferableRecordId}`,
        viewETRRecord: true,
        viewETRButtontext: 'View Request',
	});

}
export default ApprovalTransactionSuccessPage
